
import BlankLayout from "@/layouts/BlankLayout.vue";
import PlatformLayout from "@/layouts/PlatformLayout.vue";

// import CmsLayout from "@/modules/cms/layouts/CmsLayout.vue";
import CmsRoute from "@/modules/cms/routes/CmsRoute";

const routes = [
  {
    path:'/',
    component:PlatformLayout,
    // component:()=> import('@/modules/workorder/pages/index/index.vue'),
    children:CmsRoute
  },
  // {
  //   path:'/cms',
  //   component:CmsLayout,
  //   // component:()=> import('@/modules/workorder/pages/index/index.vue'),
  //   children:CmsRoute
  // },
  {
    path:'/login',
    component:BlankLayout,
    children:[
      {
        path: '/login/index',
        name:'login',
        component:() => import('@/pages/login/index.vue'),
      },

    ]
  },
]
export default routes